import { FormDefDependenciesReadModel } from "@Alternatives/Forms/Domain/readmodels";

export class FormDependenciesDialogViewModel
{
    opened: boolean = false;
    initialized: boolean = false;

    id: number | null = null;
    name: string | null = null;
    deps: FormDefDependenciesReadModel | null = null;

    show(id: number, name: string)
    {
        this.initialized = false;
        this.id = id;
        this.name = name;
        this.deps = null;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.initialized = false;
        this.id = null;
        this.name = null;
        this.deps = null;
    }

    setData(deps: FormDefDependenciesReadModel)
    {
        this.deps = deps;
        this.initialized = true;
    }
}


